import { create } from "zustand";
import { persist } from "zustand/middleware";
import { customStorage } from "../utils";

// Create the zustand store with persist middleware
const useLocalizationStore = create()(
  persist(
    (set) => ({
      language: "en", // Default language is 'en'
      setLanguage: (language) => set({ language }), // Update the language
    }),
    {
      name: "localization-storage", // The name of the storage for persistence
      storage: customStorage, // Using localStorage to persist the state
    }
  )
);

export default useLocalizationStore;
